import { Trash, Plus } from "@phosphor-icons/react";

export const PolicyRow = ({ policy, onQuotaChange, onSave, onDelete }) => (
  <div className="flex flex-wrap items-center gap-3 pb-3 border-b border-stone-100 last:border-0">
    <div className="flex-1 min-w-[140px]">
      <div className="font-semibold text-sm">{policy.name}</div>
      <div className="text-xs text-stone-500">Code: {policy.leave_type}</div>
    </div>
    <input type="number" min="0" value={policy.annual_quota} data-testid={`policy-quota-${policy.leave_type}`}
      onChange={(e) => onQuotaChange(e.target.value)}
      className="w-24 min-h-[44px] px-3 rounded-lg border border-stone-300 text-right tabular-nums" />
    <span className="text-xs text-stone-500">days/yr</span>
    <button onClick={onSave} data-testid={`save-policy-${policy.leave_type}`}
      className="tap-scale px-5 py-2.5 rounded-full bg-secondary text-white text-sm font-bold hover:bg-[#1E2B22] transition-colors duration-200">Save</button>
    <button onClick={onDelete} data-testid={`delete-policy-${policy.leave_type}`}
      className="w-9 h-9 flex items-center justify-center rounded-full text-stone-400 hover:text-red-600 transition-colors duration-200"><Trash size={16} /></button>
  </div>
);

export const NewPolicyForm = ({ value, onChange, onSubmit }) => (
  <form onSubmit={onSubmit} className="flex flex-wrap items-end gap-3 pt-2">
    <div>
      <label className="text-xs font-semibold text-stone-500">Code</label>
      <input required maxLength={4} placeholder="ML" value={value.leave_type} onChange={(e) => onChange({ ...value, leave_type: e.target.value })} data-testid="new-policy-code" className="mt-1 block w-20 min-h-[44px] px-3 rounded-lg border border-stone-300 uppercase" />
    </div>
    <div className="flex-1 min-w-[160px]">
      <label className="text-xs font-semibold text-stone-500">Name</label>
      <input required placeholder="Maternity Leave" value={value.name} onChange={(e) => onChange({ ...value, name: e.target.value })} data-testid="new-policy-name" className="mt-1 block w-full min-h-[44px] px-3 rounded-lg border border-stone-300" />
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Quota</label>
      <input type="number" min="0" required value={value.annual_quota} onChange={(e) => onChange({ ...value, annual_quota: e.target.value })} data-testid="new-policy-quota" className="mt-1 block w-24 min-h-[44px] px-3 rounded-lg border border-stone-300 text-right" />
    </div>
    <button type="submit" data-testid="add-policy-button" className="tap-scale flex items-center gap-1 px-5 py-3 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200"><Plus size={16} weight="bold" /> Add</button>
  </form>
);
